// extracted by mini-css-extract-plugin
export default {"message":"ErrorScreen_message__Lb--W"};